import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from 'lexical'
import { useEffect } from 'react'
import { BaseNode } from '../nodes/BaseNode'
import { $insertNode1, getCurrentNode } from '../utils/NodeUtils'

export function SpEnterKeyPlugin() {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        return editor.registerCommand(
            KEY_ENTER_COMMAND,
            (event) => {
                editor.update(() => {
                    const currentNode = getCurrentNode() as BaseNode
                    if (!currentNode) return

                    const nextType = currentNode.next

                    if (nextType != null) {
                        $insertNode1({ type: nextType, refNode: currentNode })
                    }
                    return true
                })
                return false
            },
            COMMAND_PRIORITY_HIGH
        )
    }, [editor])

    return null
}
